import React from 'react';

import { useAIContext } from '@atlassian/ai-smart-button-api';

import { Greeting } from './greeting';
import { Reference } from './reference';

export function HeadingSection({ name }: { name: string }) {
	const context = useAIContext();

	return context ? <Reference /> : <Greeting name={name} />;
}
